<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <LoginForm close @close-dialog="close" />
    </v-dialog>
  </v-row>
</template>


<script>
import LoginForm from "@/components/authentication/LoginForm";

export default {
  props: ["dialog"],
  components: {
    LoginForm
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    }
  }
};
</script>